<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K099Fx/tc-custom/9781488086946.jpg?1726617345531" alt="This image is the cover for the book Lady Olivia and the Infamous Rake, The Beauchamp Heirs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lady Olivia and the Infamous Rake, The Beauchamp Heirs
      </h1>
      <p class="bookDescription body article font2">
        <b>How utterly mortifying to be rejected by a rake!</b><br/><br/>Sneaking off to Vauxhall Gardens lands Lady Olivia Beauchamp in a bit more trouble than she expected—but after being plucked from peril by resolute bachelor Lord Hugo Alastair, she is secretly outraged that he doesn’t even try to steal a kiss! He’s a notorious rake among the ton, and as a result, utterly forbidden to an innocent debutante like her—the daughter of a duke, no less. But their attraction is magnetic. Will she risk her reputation for a passionate encounter?<br/><br/><b>Praise for the romances of Janice Preston</b><br/><br/>“One of the deepest, most lovable heroes I’ve read about in quite some time.” —<i>All About Romance</i><br/><br/>“A captivating, sweet tale.” —<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janice Preston
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20d49124